import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-global-navigation.css';
var getClassNameList = classNames.bind(styles);
var GlobalNavigationRow = function (props) {
  var _a;
  var className = props.className,
    children = props.children,
    secondary = props.secondary,
    fullWidth = props.fullWidth;
  var position = secondary ? 'secondary' : 'primary';
  var baseClassName = 'global-navigation-row';
  var wrapperClassNames = getClassNameList(baseClassName, position, className);
  var containerClassNames = getClassNameList("".concat(baseClassName, "-container"), (_a = {}, _a["".concat(baseClassName, "-container-fullWidth")] = fullWidth, _a));
  return React.createElement("section", {
    className: wrapperClassNames
  }, React.createElement("div", {
    className: containerClassNames
  }, children));
};
GlobalNavigationRow.displayName = 'GlobalNavigationRow';
export { GlobalNavigationRow };